module.exports = __webpack_public_path__ + "jizvy_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/jizvy_1_after_tn.jpg
// module id = 1417
// module chunks = 0